export function normalizeTrainingEntryTypeOption(item) {
  const value = String(item?.value || '').trim();
  if (!value) {
    return null;
  }

  return {
    value,
    label: String(item?.label || item?.value || '').trim() || value,
    isDayService: Boolean(item?.isDayService),
    supportsA3Za3: Boolean(item?.supportsA3Za3),
    supportsTGroup: Boolean(item?.supportsTGroup),
    supportsHonorar: Boolean(item?.supportsHonorar),
    keywordMode: String(item?.keywordMode || 'optional').toLowerCase(),
    hoursQuestionMode: String(item?.hoursQuestionMode || 'required').toLowerCase(),
    responsibleQuestionMode: String(item?.responsibleQuestionMode || '').trim(),
    responsibleQuestionText: String(item?.responsibleQuestionText || '').trim(),
    eventContextMode: String(item?.eventContextMode || '').trim(),
    timeQuestionText: String(item?.timeQuestionText || '').trim(),
    timeEntryMode: String(item?.timeEntryMode || '').trim(),
    autoResponsibleMode: String(item?.autoResponsibleMode || '').trim(),
    pauseMode: String(item?.pauseMode || '').trim(),
    pdfProtocolMode: String(item?.pdfProtocolMode || '').trim(),
    serviceDurationLabel: String(item?.serviceDurationLabel || '').trim(),
    protocolCode: String(item?.protocolCode || '').trim(),
    scaleWorkHours: Boolean(item?.scaleWorkHours),
    visibilityMode: String(item?.visibilityMode || '').trim(),
  };
}

export function normalizeTrainingEntryTypeOptions(items) {
  if (!Array.isArray(items)) {
    return [];
  }

  return items
    .map((item) => normalizeTrainingEntryTypeOption(item))
    .filter(Boolean);
}